import React from 'react';
import './App.css';
import AppRouter from './components/AppRouter/AppRouter';

function App() {
    return ( <
        div className = "App" >
          <AppRouter/> 
        </div>
    );
}

export default App;